<template>
  <div class="layout">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout',
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  align-items: stretch;
}
</style>
